import * as Utils from './utils/utils';
import { RoamingDictionary } from '@editor/roaming-dictionary';
import { getGuid } from 'owa-guid';
import { trace } from 'owa-trace';

let roamingDictionary: RoamingDictionary | undefined = undefined;

export function preloadRoamingDictionary(): void {
    getRoamingDictionary();
}

export async function getRoamingDictionary(): Promise<RoamingDictionary> {
    if (roamingDictionary) {
        trace.info('[roamingDictionary] Instance of roaming dictionary already exists. Returning');
        return roamingDictionary;
    } else {
        const proofingLocale = await Utils.getProofingLocale();
        roamingDictionary = Utils.initializeRoamingDictionary(proofingLocale ?? 'en');
        if (roamingDictionary) {
            trace.info('[roamingDictionary] Loading word list from service');
            const result = await roamingDictionary.loadWordListFromRoamingService(getGuid());
            if (result.success) {
                trace.info('[roamingDictionary] Word list loaded successfully');
                Utils.initializeRoamingDictionaryAutoSaveTimer(roamingDictionary);
            } else {
                trace.info(`[roamingDictionary] Error loading word list: ${result.errorMessage}`);
            }
        } else {
            trace.info('[roamingDictionary] iniitalizeRoamingDictionary failed');
        }

        return roamingDictionary;
    }
}

export async function saveRoamingDictionary(): Promise<boolean> {
    if (roamingDictionary && (await Utils.saveRoamingDictionaryInternal(roamingDictionary))) {
        Utils.resetAutoSaveInterval(roamingDictionary);
        return true;
    }

    return false;
}

export function clearRoamingDictionary() {
    roamingDictionary = undefined;
}
